import React from "react";
import {Descriptions, Tooltip, Typography} from "antd";
import {DateTimeFormat} from "../shared/DateTimeFormat";
import {QuestionCircleOutlined, WarningOutlined} from "@ant-design/icons";

class DomainHealthBox extends React.Component {

    render() {
        const { Text } = Typography;

        let orIps = this.props.domain.additional_ip_addresses.map(ip => ip.ip_address).join(', ');

        let resolved_ip_address;

        if(this.props.health.resolved_ip_address) {
            if(this.props.health.resolved_ip_address !== this.props.ip_address.ip_address && this.props.domain.additional_ip_addresses.indexOf(this.props.health.resolved_ip_address) === -1) {
                resolved_ip_address = <span><Text type='danger'>{this.props.health.resolved_ip_address}</Text> <Tooltip title={'Your domain ' + this.props.domain + ' does not resolve correctly. It must resolve to ' + this.props.ip_address.ip_address + '' + (this.props.domain.additional_ip_addresses.length > 0 ? ' or to additional IP addresses: ' + orIps : '') + '! Check your DNS zone records.'}><QuestionCircleOutlined /></Tooltip></span>;
            } else {
                resolved_ip_address = this.props.health.resolved_ip_address;
            }
        } else {
            resolved_ip_address = <span><Text type='danger'>Did not resolve!</Text> <Tooltip title={'Your domain ' + this.props.domain.domain + ' does not resolve correctly. It must resolve to ' + this.props.domain.ip_address.ip_address + '! Check your DNS zone records.'}><QuestionCircleOutlined /></Tooltip></span>;
        }

        let www_resolved_ip_address;

        if(this.props.health.resolved_www_ip_address) {
            if(this.props.health.resolved_www_ip_address !== this.props.ip_address.ip_address && this.props.domain.additional_ip_addresses.indexOf(this.props.health.resolved_www_ip_address) === -1) {
                www_resolved_ip_address = <span><Text type='danger'>{this.props.health.resolved_www_ip_address}</Text> <Tooltip title={'Your domain www.' + this.props.domain.domain + ' does not resolve correctly. It must resolve to ' + this.props.domain.ip_address.ip_address + '' + (this.props.domain.additional_ip_addresses.length > 0 ? ' or to additional IP addresses: ' + orIps : '') + '! Check your DNS zone records.'}><QuestionCircleOutlined /></Tooltip></span>;
            } else {
                www_resolved_ip_address = this.props.health.resolved_www_ip_address;
            }
        } else {
            www_resolved_ip_address = <span><Text type='danger'>Did not resolve!</Text> <Tooltip title={'Your domain www.' + this.props.domain.domain + ' does not resolve correctly. It must resolve to ' + this.props.domain.ip_address.ip_address + '! Check your DNS zone records.'}><QuestionCircleOutlined /></Tooltip></span>;
        }

        return <div>
            <Descriptions bordered size='small' column={1}>
                <Descriptions.Item style={{width: '50%'}} label='Last check'>
                    <DateTimeFormat value={this.props.health.date_health_checked} />
                </Descriptions.Item>
                <Descriptions.Item label={this.props.domain.domain}>{resolved_ip_address}</Descriptions.Item>
                <Descriptions.Item label={'www.' + this.props.domain.domain}>{www_resolved_ip_address}</Descriptions.Item>
                <Descriptions.Item label='Expired'>{this.props.health.is_expired ? <Text type='danger'>Yes</Text> : 'No'}</Descriptions.Item>
                <Descriptions.Item label='Cloudflare'>{this.props.health.is_cloudflare ? 'Yes' : 'No'}</Descriptions.Item>
                <Descriptions.Item label='NXDomain'>{this.props.health.is_nxdomain ? <Text type='danger'>Yes</Text> : 'No'}</Descriptions.Item>
            </Descriptions>
            <small><WarningOutlined /> Just updated your DNS? Changes may take up to 5 minutes to appear.</small>
        </div>;
    }
}

export default DomainHealthBox;